import React from 'react'

const HeadingOfSection = (props) => {
  return (
    <div className='flex flex-col gap-6 md:gap-10 items-center justify-center w-full pt-8 md:pt-16 z-[100]'>
        <h1 className='my-0 text-[25px] xs:text-[30px] md:text-[35px] lg:text-[40px] xxxl:text-[50px] text-primary02 font-bold text-center'>{props.header}<span className='text-primary relative after:absolute after:content-[""] after:w-full after:h-2 after:bg-secondary after:left-0 after:bottom-[6px] after:z-[-1]'>{props.span}</span></h1>
        <p className=' w-[90%] md:w-[85%] lg:w-3/4 text-center text-[15px] sm:text-[18px] md:text-[23px] xl:text-[30px] text-primary02'>{props.text}</p>
    </div>
  )
}

export default HeadingOfSection